const callDirections = ["INBOUND", "OUTBOUND"];

const TRANSCRIPT_STATUSES = {
  PENDING: "pending",
  PROCESSING: "processing",
  COMPLETED: "completed",
  FAILED: "failed",
  SKIPPED: "skipped",
};

// Neither status can ever produce something to read, so both count as having no
// transcript — which is also how the Has/No Transcript filter counts them.
const TRANSCRIPT_STATUSES_WITHOUT_AFFORDANCE = [
  TRANSCRIPT_STATUSES.SKIPPED,
  TRANSCRIPT_STATUSES.FAILED,
];

const TRANSCRIPT_STATUSES_IN_PROGRESS = [
  TRANSCRIPT_STATUSES.PENDING,
  TRANSCRIPT_STATUSES.PROCESSING,
];

// Which eligibility rule skipped a recording. Only ever set on a skipped
// transcript, and absent on rows written before it was recorded.
const TRANSCRIPT_SKIP_REASONS = {
  NOT_REACHED: "not_reached",
  TOO_SHORT: "too_short",
};

// What asking for a call to be transcribed did. NOT_REACHED and TOO_SHORT
// repeat the skip-reason spellings so one table covers both.
const TRANSCRIPT_REQUEST_OUTCOMES = {
  QUEUED: "queued",
  ALREADY_REQUESTED: "already_requested",
  NO_RECORDING: "no_recording",
  NOT_DISPOSITIONED: "not_dispositioned",
  NOT_REACHED: "not_reached",
  TOO_SHORT: "too_short",
  NOT_FOUND: "not_found",
};

// Who a transcript's speaker is. "unknown" covers calls with more than two
// participants, where nobody can be attributed with confidence.
const SPEAKER_ROLES = {
  REP: "rep",
  CONTACT: "contact",
  UNKNOWN: "unknown",
};

const callConstants = {
  callDirections,
  SPEAKER_ROLES,
  TRANSCRIPT_REQUEST_OUTCOMES,
  TRANSCRIPT_SKIP_REASONS,
  TRANSCRIPT_STATUSES,
  TRANSCRIPT_STATUSES_IN_PROGRESS,
  TRANSCRIPT_STATUSES_WITHOUT_AFFORDANCE,
};
export default callConstants;
